// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__3m8xl","open":"BurgerMenu_open__1feNB"};